/**
 * Show/hide header phone CTA by business hours (settings from #business-hours-phone-config).
 * Deferred + idle-scheduled to avoid main-thread work during critical path.
 */
(function () {
  function readConfig() {
    var el = document.getElementById('business-hours-phone-config');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  }

  function apply(config) {
    var wrappers = document.querySelectorAll('.contact-phone-wrapper');
    if (!wrappers.length) return;

    var BUSINESS_TIMEZONE = config.timezone;
    var openHour = Number(config.openHour);
    var closeHour = Number(config.closeHour);
    var manualHide = config.manualHide === true;
    var forceShow = config.forceShow === true;

    var now = new Date();
    var businessTime = new Date(now.toLocaleString('en-US', { timeZone: BUSINESS_TIMEZONE }));
    var hours = businessTime.getHours();
    var day = businessTime.getDay();
    var isWeekday = day >= 1 && day <= 5;
    var isWithinHours = isWeekday && hours >= openHour && hours < closeHour;

    wrappers.forEach(function (wrapper) {
      var searchWrap = document.querySelector('.search-mobile-wrapper');
      if (manualHide === true && forceShow === false) {
        wrapper.classList.add('d-none');
        if (searchWrap) searchWrap.classList.remove('d-none');
        return;
      }
      if (forceShow === true) {
        wrapper.classList.remove('d-none');
        if (searchWrap) searchWrap.classList.add('d-none');
        return;
      }
      if (!isWithinHours) {
        wrapper.classList.add('d-none');
        if (searchWrap) searchWrap.classList.remove('d-none');
      } else {
        wrapper.classList.remove('d-none');
        if (searchWrap) searchWrap.classList.add('d-none');
      }
    });
  }

  function schedule() {
    var config = readConfig();
    if (!config) return;
    function run() {
      apply(config);
    }
    if (window.requestIdleCallback) {
      requestIdleCallback(run, { timeout: 3000 });
    } else {
      setTimeout(run, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
